module.exports = __webpack_public_path__ + "dashboard.b6c24f68edf1b4a796d4";


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend/src/assets/img/admin/dashboard.jpg
// module id = ../../../../../src/assets/img/admin/dashboard.jpg
// module chunks = main